import React from 'react';
// import './Header.css';

const Header = () => {

  const closeMenu = () => {
    document.getElementById('menu-toggle').checked = false;
  }

  return (
    <header>
      <nav>
        <div className="logo">Zirae Chemicals</div>

        {/* Hamburger toggle */}
        <input type="checkbox" id="menu-toggle" className="menu-toggle" />

        {/* Hamburger / Cancel icon */}
        <label htmlFor="menu-toggle" className="menu-icon">
          <span></span>
          <span></span>
          <span></span>
        </label>

        {/* Sidebar nav links */}
        <div className="nav-links">
          <a href="#home" onClick={closeMenu}>Home</a>
          <a href="#about" onClick={closeMenu}>About</a>
          <a href="#services" onClick={closeMenu}>Services</a>
          <a href="#contact" onClick={closeMenu}>Contact</a>
          <a href="#book" className="book-btn" onClick={closeMenu}>Book Us</a>
        </div>

        {/* Overlay */}
        <div className="overlay" onClick={closeMenu}></div>
      </nav>
    </header>
  );
};

export default Header;
